import { priceStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import { ProductPriceStyles } from "@tCentro/Overrides/Components/ProductPrice";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

priceStyles.productPrice = {
    loginContainer: {
        css: css`
            display: none;
        `,
    },
    price: {
        priceText: { size: 26 },
        unitOfMeasureText: { size: 26 },
        salePriceLabeltext: {
            css: css`
                font-size: 24px;
                font-weight: 600;
                color: ${getProp("theme.typography.p.color")};
                margin-right: 10px;
            `,
        },
    },
    priceWrapper: {
        css: css`
            > div[class^="sc"] {
                > span {
                    font-size: 32px;
                    font-weight: 700;
                }
                span[data-test-selector="productPrice_unitOfMeasureLabel"] {
                    font-size: ${TYPOGRAPHY.size.large};
                    line-height: ${TYPOGRAPHY.lineHeight.base};
                }
                h4 {
                    font-size: 32px;
                    font-weight: ${TYPOGRAPHY.weight.bold};
                    line-height: 40px;
                    span {
                        font-size: 18px;
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            > div[class^="sc"] {
                                > span {
                                    font-weight: 600;
                                }
                                h4 {
                                    font-size: 24px;
                                    font-weight: 600;
                                    span {
                                        font-size: 14px;
                                    }
                                }
                            }
                        `,
                        css`
                            > div[class^="sc"] {
                                > span {
                                    font-weight: 600;
                                }
                                h4 {
                                    font-size: 24px;
                                    span {
                                        font-size: 14px;
                                    }
                                }
                            }
                        `,
                        css`
                            > div[class^="sc"] {
                                > span {
                                    font-weight: 600;
                                    font-size: 24px;
                                }
                                h4 {
                                    font-size: 24px;
                                    font-weight: 600;
                                    span {
                                        font-size: 14px;
                                    }
                                }
                            }
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    wrapper: {
        css: css`
            margin: 18px 0px;
            margin-bottom: 0px;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        margin: 10px 0px;
                    `,
                    css`
                        margin: 10px 0px;
                    `,
                    css`
                        margin: 10px 0px 5px 0px;
                    `,
                    null,
                    null,
                ]);
            }}
        `,
    },
} as ProductPriceStyles;
